import React, { useEffect } from "react";
import { EventListView } from "./EventListView";
import { HeadLine } from "../components/HeadLine";

export const EventsView = (props) => {
  useEffect(() => {
    return () => {
      // Cleanup resize when unmounting
      if (window.parentIFrame) window.parentIFrame.size();
    };
  }, []);

  return (
    <>
      <div className="App events-view-container" style={{ overflow: "hidden" }}>
        <div className="app-content">
          <HeadLine />
          <EventListView />
        </div>
      </div>
    </>
  );
};
